import React from 'react';
import FormLabel from './FormLabel';
import { Control, Controller } from 'react-hook-form';
import ErrorMessage from './ErrorMessage';

type TextInputProps = {
	name: string;
	label?: string;
	maxLength?: number;
	placeholder?: string;
	control: Control<any>;
	errorMessage: string | undefined;
	variant?: 'classCode' | 'uppercase';
	disabled?: boolean;
};

export default function TextInput({
	name,
	label,
	maxLength,
	placeholder,
	control,
	errorMessage,
	variant,
	disabled,
}: TextInputProps) {
	return (
		<div className="relative">
			{label && <FormLabel labelFor={name} labelName={label} />}
			<Controller
				control={control}
				name={name}
				render={({ field: { ref, ...field } }) => (
					<div className="mt-2 rounded-md">
						<input
							disabled={disabled || false}
							type="text"
							autoComplete="none"
							id={name}
							maxLength={maxLength || 255}
							placeholder={placeholder || ''}
							className={`${errorMessage ? 'app-input-error' : 'app-input-default'}`}
							aria-invalid={!!errorMessage}
							aria-describedby={`${name}-error`}
							{...field}
							onInput={(e: React.FormEvent<HTMLInputElement>) => {
								if (variant === 'classCode') {
									const regex = /^[a-z0-9]+$/i;
									if (e.currentTarget.value !== '') {
										// Split the input into an array and check each character
										const chars = e.currentTarget.value.split('');
										const filtered = chars.filter((char) => regex.test(char));
										// Update the value of the input with only alphanumeric characters
										e.currentTarget.value = filtered.join('').toUpperCase();
									}
								} else if (variant === 'uppercase') {
									e.currentTarget.value = e.currentTarget.value.trim().toUpperCase();
								} else e.currentTarget.value = e.currentTarget.value.trimStart();
							}}
						/>
					</div>
				)}
			/>
			{!!errorMessage && <ErrorMessage inputId={name} errorMessage={errorMessage} />}
		</div>
	);
}
